module.exports = __webpack_public_path__ + "img/Menu-02.b96e0d60.png";